import React from 'react'

import classes from './SplashScreen.scss'
import Logo from '../Logo/Logo'

const splashScreen = () => {
  return (
    <div className={classes.SplashScreen}>
      <div className={classes.SplashLogoWrapper}>
        <Logo />
      </div>
    </div>
  )
}

export default splashScreen